var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new"},[_c('Title'),_vm._v(" "),_c('div',{staticClass:"new_box"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"new_list"},[_c('div',{staticClass:"newdetail_content",domProps:{"innerHTML":_vm._s(_vm.mch_info)}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab4a1a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/introduce/introduce.vue
// module id = null
// module chunks = 